import { createTheme } from "@mui/material/styles"

// Keep MUI's default Roboto typography (loaded in public/index.html) and only
// vary the palette between modes. The CSS custom properties in index.css are
// kept in sync with these values.
const baseTheme = {
    typography: {
        fontSize: 14
    }
}

const lightTheme = createTheme({
    ...baseTheme,
    palette: {
        mode: "light"
    }
})

const darkTheme = createTheme({
    ...baseTheme,
    palette: {
        mode: "dark",
        background: {
            default: "#121212",
            paper: "#1e1e1e"
        },
        text: {
            primary: "#e6e6e6",
            secondary: "#9e9e9e"
        },
        divider: "rgba(255, 255, 255, 0.14)",
        primary: {
            main: "#90caf9"
        },
        success: {
            main: "#6ee06e"
        },
        error: {
            main: "#ff7b7b"
        }
    }
})

export { darkTheme, lightTheme }
